import { render } from "./AdminOverview.vue?vue&type=template&id=1f7a0092&scoped=true"
import script from "./AdminOverview.vue?vue&type=script&lang=js"
export * from "./AdminOverview.vue?vue&type=script&lang=js"

import "./AdminOverview.vue?vue&type=style&index=0&id=1f7a0092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7a0092"]])

export default __exports__